module.exports = __webpack_public_path__ + "static/media/murshidabad_road.7ee0fa89.jpg";